import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBonusAvailable } from 'core/actions/bonus';
import {
  selectBonusAvailableConfig, selectBonusAvailableIsLoading, selectBonusAvailableIsLoaded,
  selectBonusAvailablePlacements, selectBonusAvailableButtonPlacement,
} from '../selectors';

export const useGetBonusAvailable = (shouldFetch = true) => {
  const dispatch = useDispatch();
  const config = useSelector(selectBonusAvailableConfig);
  const isLoading = useSelector(selectBonusAvailableIsLoading);
  const isLoaded = useSelector(selectBonusAvailableIsLoaded);
  const placements = useSelector(selectBonusAvailablePlacements);
  const bonusButtonPlacement = useSelector(selectBonusAvailableButtonPlacement);

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (!isLoading && !isLoaded && shouldFetch) {
        const { api: { params, options } } = config;
        dispatch(fetchBonusAvailable(params, options));
      }
    }, 10);

    return () => clearTimeout(timerId);
  }, [isLoaded, isLoading, shouldFetch]);

  return {
    isLoaded,
    isLoading,
    placements,
    bonusButtonPlacement,
  };
};
